import { Maybe, QuizRevealAnswerEnum } from '@/types/schema';

import { QuizEditorDetailsFragment } from '../graphql/fragments/generated/QuizEditorContent';

export const getIsQuestionImported = (quizContent: QuizEditorDetailsFragment, questionId: string) =>
  Boolean(quizContent.questions.find((question) => question.id === questionId)?.actualQuestionId);

const DEFAULT_PERCENTAGE = 80;

export const getQuizPassingPercentage = (score?: Maybe<number>) => score ?? DEFAULT_PERCENTAGE;

export const getDefaultQuizRevealAnswers = (revealAnswers?: Maybe<QuizRevealAnswerEnum>) =>
  revealAnswers ?? QuizRevealAnswerEnum.AfterQuiz;
